"use strict";

var _classCallCheck = require("/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var JsonLogFormat =
/*#__PURE__*/
function () {
  function JsonLogFormat(pretty) {
    _classCallCheck(this, JsonLogFormat);

    this.pretty = false;
    this.pretty = pretty;
  }

  _createClass(JsonLogFormat, [{
    key: "format",
    value: function format(msg, metadata) {
      var logMsgObj = Object.assign({}, metadata, msg);

      if (this.pretty) {
        return JSON.stringify(logMsgObj, undefined, 2) + "\n"; // each message is split by an empty line
      } else {
        return JSON.stringify(logMsgObj);
      }
    }
  }, {
    key: "getName",
    value: function getName() {
      return this.pretty ? JsonLogFormat.FORMAT_NAME_PRETTY : JsonLogFormat.FORMAT_NAME;
    }
  }]);

  return JsonLogFormat;
}();

JsonLogFormat.FORMAT_NAME = "json";
JsonLogFormat.FORMAT_NAME_PRETTY = "json_pretty";
exports.JsonLogFormat = JsonLogFormat;